/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminActivitiesFillRateOverallDto { 
    /**
     * Activities counted, excluding deleted ones
     */
    activities: number;
    /**
     * Activities nobody ever joined, organiser alone
     */
    neverJoined: number;
    /**
     * Share of activities nobody ever joined, as a percentage
     */
    neverJoinedShare: number;
    /**
     * Average number of people on an activity, organiser included
     */
    averageAttendees: number;
    /**
     * Fill rate against sport reference capacities, as a percentage. Null when no sport has a definition.
     */
    adjustedFillRate: number | null;
    /**
     * Fill rate against the capacities organisers typed, as a percentage
     */
    declaredFillRate: number;
}

